module.exports = __webpack_public_path__ + "static/stringLogo-00f2b2b7f2553716018c9642c43c56eb.png";